import { loadScript, releaseScript } from '../../../browser/ScriptLoader';
import { GOOGLE_GTAG_SCRIPT_BASE, type GoogleGtag } from './types';

type WindowWithGtag = Window & {
  dataLayer?: unknown[];
  gtag?: GoogleGtag;
};

function getWindow(): WindowWithGtag | null {
  return typeof window !== 'undefined' ? (window as WindowWithGtag) : null;
}

function ensureGtagStub(): GoogleGtag {
  const win = getWindow();
  if (!win) throw new Error('[GoogleScriptLoader] window unavailable');

  win.dataLayer = win.dataLayer || [];
  if (!win.gtag) {
    win.gtag = function gtag(...args: unknown[]) {
      win.dataLayer?.push(args);
    };
  }
  return win.gtag;
}

export class GoogleScriptLoader {
  private loadedSrc: string | null = null;

  async load(primaryTagId: string, timeoutMs = 10_000): Promise<GoogleGtag> {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      throw new Error('[GoogleScriptLoader] Browser APIs unavailable');
    }

    const gtag = ensureGtagStub();
    const src = `${GOOGLE_GTAG_SCRIPT_BASE}?id=${encodeURIComponent(primaryTagId)}`;

    await loadScript({
      src,
      id: 'pixel-v2-google-gtag',
      timeoutMs,
    });

    this.loadedSrc = src;
    gtag('js', new Date());
    return gtag;
  }

  release(): void {
    if (this.loadedSrc) {
      releaseScript(this.loadedSrc);
      this.loadedSrc = null;
    }
  }
}
